<template>
    <Multiselect
        v-model="selectedState"
        class="form-control-lg state-select"
        :placeholder="$t('common.form.state')"
        :options="states"
        :searchable="true"
        :canDeselect="false"
        @search-change="autocomplete"
        ref="stateSelect"
        @change="stateSelected"
    />
</template>

<script>
import {nextTick} from 'vue';

import Multiselect from '@vueform/multiselect';

export default {
    name: 'StateSelect',
    components: {
        Multiselect
    },
    props: ['modelValue', 'autocompleteAttribute'],
    emits: ['update:modelValue'],
    //Normally I declare methods after data, but making an exception so that the long list of states goes last.
    methods: {
        autocomplete: function(query) {
            if (query) {
                let matchingState = this.states.find(state => state.value === query.toUpperCase() || state.label.toUpperCase() === query.toUpperCase())
                if (matchingState !== undefined) {
                    this.$refs.stateSelect.select(matchingState.value, matchingState.label);
                } else {
                    this.$refs.stateSelect.clear();
                }
            }
        },
        stateSelected: function(value) {
            this.$emit('update:modelValue', value);
        },
        updateAutocompleteAttribute() {
            //Hack to get the appropriate autocomplete attribute on the multiselect search.
            if (this.$attrs.id && this.autocompleteAttribute) {
                document.querySelector(`#${this.$attrs.id} .multiselect-search`).setAttribute('autocomplete', this.autocompleteAttribute);
            }
        }
    },
    mounted() {
        this.updateAutocompleteAttribute();
    },
    watch: {
        autocompleteAttribute() {
            //Let the DOM settle out and then update the autocomplete attribute.
            nextTick(() => {
                this.updateAutocompleteAttribute();
            });
        }
    },
    data() {
        return {
            selectedState: null,
            states: [
                {
                    label: 'Alabama',
                    value: 'AL',
                },
                {
                    label: 'Alaska',
                    value: 'AK',
                },
                {
                    label: 'American Samoa',
                    value: 'AS',
                },
                {
                    label: 'Arizona',
                    value: 'AZ',
                },
                {
                    label: 'Arkansas',
                    value: 'AR',
                },
                {
                    label: 'Armed Forces Americas',
                    value: 'AA',
                },
                {
                    label: 'Armed Forces Europe',
                    value: 'AE',
                },
                {
                    label: 'Armed Forces Pacific',
                    value: 'AP',
                },
                {
                    label: 'California',
                    value: 'CA',
                },
                {
                    label: 'Colorado',
                    value: 'CO',
                },
                {
                    label: 'Connecticut',
                    value: 'CT',
                },
                {
                    label: 'Delaware',
                    value: 'DE',
                },
                {
                    label: 'District of Columbia',
                    value: 'DC',
                },
                {
                    label: 'Federated States of Micronesia',
                    value: 'FM',
                },
                {
                    label: 'Florida',
                    value: 'FL',
                },
                {
                    label: 'Georgia',
                    value: 'GA',
                },
                {
                    label: 'Guam',
                    value: 'GU',
                },
                {
                    label: 'Hawaii',
                    value: 'HI',
                },
                {
                    label: 'Idaho',
                    value: 'ID',
                },
                {
                    label: 'Illinois',
                    value: 'IL',
                },
                {
                    label: 'Indiana',
                    value: 'IN',
                },
                {
                    label: 'Iowa',
                    value: 'IA',
                },
                {
                    label: 'Kansas',
                    value: 'KS',
                },
                {
                    label: 'Kentucky',
                    value: 'KY',
                },
                {
                    label: 'Louisiana',
                    value: 'LA',
                },
                {
                    label: 'Maine',
                    value: 'ME',
                },
                {
                    label: 'Marshall Islands',
                    value: 'MH',
                },
                {
                    label: 'Maryland',
                    value: 'MD',
                },
                {
                    label: 'Massachusetts',
                    value: 'MA',
                },
                {
                    label: 'Michigan',
                    value: 'MI',
                },
                {
                    label: 'Minnesota',
                    value: 'MN',
                },
                {
                    label: 'Missouri',
                    value: 'MO',
                },
                {
                    label: 'Mississippi',
                    value: 'MS',
                },
                {
                    label: 'Montana',
                    value: 'MT',
                },
                {
                    label: 'Nebraska',
                    value: 'NE',
                },
                {
                    label: 'Nevada',
                    value: 'NV',
                },
                {
                    label: 'New Hampshire',
                    value: 'NH',
                },
                {
                    label: 'New Jersey',
                    value: 'NJ',
                },
                {
                    label: 'New Mexico',
                    value: 'NM',
                },
                {
                    label: 'New York',
                    value: 'NY',
                },
                {
                    label: 'North Carolina',
                    value: 'NC',
                },
                {
                    label: 'North Dakota',
                    value: 'ND',
                },
                {
                    label: 'Northern Mariana Islands',
                    value: 'MP',
                },
                {
                    label: 'Ohio',
                    value: 'OH',
                },
                {
                    label: 'Oklahoma',
                    value: 'OK',
                },
                {
                    label: 'Oregon',
                    value: 'OR',
                },
                {
                    label: 'Pennsylvania',
                    value: 'PA',
                },
                {
                    label: 'Palau',
                    value: 'PW',
                },
                {
                    label: 'Puerto Rico',
                    value: 'PR',
                },
                {
                    label: 'Rhode Island',
                    value: 'RI',
                },
                {
                    label: 'South Carolina',
                    value: 'SC',
                },
                {
                    label: 'South Dakota',
                    value: 'SD',
                },
                {
                    label: 'Tennessee',
                    value: 'TN',
                },
                {
                    label: 'Texas',
                    value: 'TX',
                },
                {
                    label: 'Utah',
                    value: 'UT',
                },
                {
                    label: 'Vermont',
                    value: 'VT',
                },
                {
                    label: 'Virgin Islands',
                    value: 'VI',
                },
                {
                    label: 'Virginia',
                    value: 'VA',
                },
                {
                    label: 'Washington',
                    value: 'WA',
                },
                {
                    label: 'West Virginia',
                    value: 'WV',
                },
                {
                    label: 'Wisconsin',
                    value: 'WI',
                },
                {
                    label: 'Wyoming',
                    value: 'WY',
                },
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.state-select {
    &.is-invalid {
        border-color: $danger;
    }
}
</style>